<template>
    <back-button :route="{ name: 'users' }" />
    <div v-if="user">
        <user-heading :user="user">
            <div class="flex items-center">
                <user-wallet-dropdown
                    :selected-wallet="selectedWallet"
                    :on-wallet-change="handleWalletChange"
                    class="mr-2"
                />
                <span
                    v-if="userPendingRecords"
                    class="ml-2 rounded bg-red-100 px-2.5 py-1.5 text-sm font-medium text-white dark:bg-red-800"
                >
                    {{ userPendingRecords }}
                </span>
                <user-dropdown :wallet="selectedWallet" />
            </div>
        </user-heading>
        <balance-cards
            :user="user"
            v-if="selectedWallet"
            :wallet="selectedWallet"
            :key="selectedWallet?.uuid || selectedWallet?.id || 'no-wallet'"
        />
        <nav-tabs :tabs="tabs" variant="compact" class="mb-2" />
        <router-view
            :user="user"
            :wallet="selectedWallet"
            :key="`wallet-${selectedWallet?.uuid || selectedWallet?.id || 'none'}`"
        />
    </div>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { mapActions, mapWritableState } from "pinia";
import Card from "../../components/layouts/Card.vue";
import NavTabs from "../../components/layouts/NavTabs.vue";
import BackButton from "../../components/layouts/navigation/BackButton.vue";
import BalanceCards from "../../components/user/BalanceCards.vue";
import { Store } from "../../stores/store";
import PermissionMixin from "../../mixins/PermissionMixin.vue";
import UserDropdown from "./UserDropdown.vue";
import UserHeading from "./UserHeading.vue";
import UserTrackings from "./audit/UserTrackings.vue";
import Commissions from "./commissions/Commissions.vue";
import Statement from "./statement/Statement.vue";
import UserWalletDropdown from "./UserWalletDropdown.vue";

export default {
    mixins: [PermissionMixin],
    components: {
        BackButton,
        NavTabs,
        BalanceCards,
        Commissions,
        Statement,
        Card,
        MenuHeadless: Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        UserDropdown,
        UserHeading,
        UserTrackings,
        UserWalletDropdown,
    },
    data() {
        return {
            selectedWallet: null,
            activeTab: "details",
            tabs: [
                {
                    name: "details",
                    label: "Detalhes",
                    route: "user.settings",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "relations",
                    label: "Relacionamentos",
                    route: "user.relations",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "products",
                    label: "Produtos",
                    route: "user.products",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "referrals",
                    label: "Indicação",
                    route: "user.referrals",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "financial",
                    label: "Financeiro",
                    route: "user.financial",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "statement",
                    label: "Extrato",
                    route: "user.statement",
                    params: { user_id: this.$route.params.user_id },
                },
                // {
                //     name: "log",
                //     label: "Log",
                //     route: "user.statement-log",
                //     params: { user_id: this.$route.params.user_id },
                // },
                {
                    name: "anticipation-histories",
                    label: "Antecipações",
                    route: "user.anticipation-histories",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "commissions",
                    label: "Comissões",
                    route: "user.commissions",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "permissions",
                    label: "Permissões",
                    route: "user.permissions",
                    params: { user_id: this.$route.params.user_id },
                },
                {
                    name: "plates",
                    label: "Placas",
                    route: "user.plates",
                    params: { user_id: this.$route.params.user_id },
                },
            ],
            loading: false,
        };
    },
    computed: {
        ...mapWritableState(Store, ["user", "userPendingRecords"]),
    },

    mounted() {
        this.fetchUser().then(() => {
            this.addPermissionNav();
        });
    },

    methods: {
        handleWalletChange(wallet) {
            this.selectedWallet = wallet;
        },
        addPermissionNav() {
            if (this.user) {
                if (this.user.is_producer) {
                    this.tabs.push({
                        name: "import-students",
                        label: "Importar Alunos",
                        route: "user.import-students",
                        params: { user_id: this.$route.params.user_id },
                    });
                }
                if (this.hasPermission('impersonate.view.history')) {
                    this.tabs.push({
                        name: "history",
                        label: "Histórico",
                        route: "user.history",
                        params: { user_id: this.$route.params.user_id },
                    });
                }
                this.tabs.push({
                    name: "audit",
                    label: "Auditoria",
                    route: "user.trackings",
                    params: { user_id: this.$route.params.user_id },
                });
            }
        },
        ...mapActions(Store, ["fetchUser"]),
        formatCurrency(value) {
            return (value / 100).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            });
        },
    },
};
</script>
